import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

function RequireSession() {
  const isAuthenticated = useSelector((state) => state.session.isAuthenticated);
  const location = useLocation();

  if (!isAuthenticated) {
    const redirectTo = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate replace to={`/login?redirect=${encodeURIComponent(redirectTo)}`} />;
  }

  return <Outlet />;
}

export default RequireSession;
